import { isMyAppWKWebView } from "@/bridge/isMyAppWKWebView";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { isDevelopment } from "./isDevelopment";

const firebaseConfig = {
  apiKey: "AIzaSyCSkIB2f4_ogEIV1zKW0WY8EixuBFU2SXA",
  authDomain: "skillscratch-98666.firebaseapp.com",
  projectId: "skillscratch-98666",
  storageBucket: "skillscratch-98666.appspot.com",
  messagingSenderId: "704483133535",
  appId: "1:704483133535:web:a86b451958ba3d1f58b3ea",
  measurementId: "G-R8XP00CW3Y",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyB2V4e59lpNitrC6w1iwCWmoMWbDsMhuDU",
//   authDomain: "scratch-3714e.firebaseapp.com",
//   projectId: "scratch-3714e",
//   storageBucket: "scratch-3714e.firebasestorage.app",
//   messagingSenderId: "794371955172",
//   appId: "1:794371955172:web:6d631a8dd40fd4236fcff1",
//   measurementId: "G-Q7Z1EB9LVX"
// };

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

if (!window.Android && !isMyAppWKWebView()) {
  if (isDevelopment()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  } else {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  const appCheckConfig = {
    provider: new ReCaptchaV3Provider('6LeZvuoqAAAAAGQxMhb9ydbOXaxggGTw5Z3VRYRq'),
    isTokenAutoRefreshEnabled: false
  };

  initializeAppCheck(app, appCheckConfig);
}